
import Lodash from 'lodash'
import Moment from "moment-timezone/builds/moment-timezone-with-data-10-year-range";

import inflection from 'lodash-inflection'
const numeral = require('numeral');
Lodash.mixin(inflection);
export default class Util extends Lodash
{
    /**
     * [Note]
     *
     * @param {String} str
     * @param {Object} replace
     * @returns {String}
     */
    static trans(str, replace= {})
    {
        // console.log({
        //     'translation_debug': process.env.MIX_TRANS_DEBUG,
        //     '!value':     !value,
        // });
        // @todo disabling this seems to prevent some alerts from showing.  They are just blank, but keys are correct and message shows if you re-enable.
        let value = _.get(window.i18n, str);

        if (!value) {
            //throw Error(`Unknown translation key ${str}`);
            return;
        }

        _.eachRight(replace, (paramVal, paramKey) => {
            while (true) {
                if (!value.includes(`:${paramKey}`)) {
                    break;
                }
                value = _.replace(value, `:${paramKey}`, paramVal);
            }
        });
        return value;
    }

    static transOrFail(str, replace) {
        try {
            let value = this.trans(str, replace);
            if(!value) {
                throw Error(`Unknown translation key ${str}`);
            }
            return value;
        }
        catch (e) {
            return false;
        }
    }

    /**
     * [Note]
     *
     * @param {String} str
     * @param {Object} replace
     * @returns {String}
     */
    static tryTrans(str, replace = {})
    {
        try {
            let trans = this.trans(str, replace);
            if(!trans) {
                return str;
            }
            return trans;
        }
        catch (e) {
            return str;
        }
    }

    static titleCase(str)
    {
        return this.startCase(this.toLower(str));
    }

    static objectDiff(object, base)
    {
        function changes(object, base)
        {
            const accumulator = {};
            Object.keys(base).forEach((key) => {
                if (object[key] === undefined) {
                    accumulator[`-${key}`] = base[key];
                }
            });
            return _.transform(
                object,
                (accumulator, value, key) => {
                    if (base[key] === undefined) {
                        accumulator[`+${key}`] = value;
                    } else if (!_.isEqual(value, base[key])) {
                        accumulator[key] = (_.isObject(value) && _.isObject(base[key])) ? changes(value, base[key]) : value;
                    }
                },
                accumulator
            );
        }

        return changes(object, base);
    }
    /**
     * Remove HTML from string
     * @param  {String} string HTML String
     * @return {String}
     */
    static stripHtml(string) {
        return _.trim(String(string || '').replace(/<[^>]*>?/gm, ''))
    }
    /**
     * Deep diff between two object, using lodash
     * @param  {Object} object Object compared
     * @param  {Object} base   Object to compare with
     * @return {Object}        Return a new object who represent the diff
     */
    static difference(object, base)
    {
        function changes(object, base)
        {
            return _.transform(object, function (result, value, key) {
                if (!_.isEqual(value, base[key])) {
                    result[key] = (_.isObject(value) && _.isObject(base[key])) ? changes(value, base[key]) : value;
                }
            });
        }

        return changes(object, base);
    }
    static guid() {
        return Math.floor((1 + Math.random()) * 0x10000)
            .toString(16)
            .substring(1);
    }

    static uuid()
    {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }

    static slugify(str)
    {
        const a = 'àáâäæãåāăąçćčđďèéêëēėęěğǵḧîïíīįìłḿñńǹňôöòóœøōõṕŕřßśšşșťțûüùúūǘůűųẃẍÿýžźż·/_,:;'
        const b = 'aaaaaaaaaacccddeeeeeeeegghiiiiiilmnnnnooooooooprrsssssttuuuuuuuuuwxyyzzz------'
        const p = new RegExp(a.split('').join('|'), 'g')

        return str.toString().toLowerCase()
            .replace(/\s+/g, '-') // Replace spaces with -
            .replace(p, c => b.charAt(a.indexOf(c))) // Replace special characters
            .replace(/&/g, '-and-') // Replace & with 'and'
            .replace(/[^\w\-]+/g, '') // Remove all non-word characters
            .replace(/\-\-+/g, '-') // Replace multiple - with single -
            .replace(/^-+/, '') // Trim - from start of text
            .replace(/-+$/, '') // Trim - from end of text
    }

    static pathFrom(pattern, params)
    {
        let url = pattern;
        for (let key in params) {
            if (TB.indexOf(url, ':'+key+'?') !== -1){
                url = url.replace(':'+key+'?', params[key]);
            }else {
                url = url.replace(':'+key, params[key]);
            }
        }

        return url;
    }

    static formatNumber(num, decimals = 0)
    {
        let format = '(0,0';
        if (decimals) {
            format += '.' + ('0'.repeat(decimals))
        }
        format += ')';

        return numeral(num).format(format);
    }

    static formatCurrency(num, shorten = true)
    {
        let totalDigits = TB.round(num).toString().length;
        let postDecimalValue = TB.round(num) - TB.round(num, 2);
        let hasDecimals = postDecimalValue > 0;
        let format;

        if (totalDigits % 3 === 2) {
            format = '($0.00a)';
        }

        if (totalDigits % 3 === 1) {
            format = '($0.00a)';
        }
        if (totalDigits % 3 === 0) {
            format = '($0a)';
        }

        if (!shorten) {
            format = '($0,0)';
        }

        let formatted = numeral(num).format(format);
        let endings = ['k', 'K', 'm', 'M', ''];
        for (let ending of endings) {
            if (formatted.endsWith(`.0${ending}`)) {
                formatted = formatted.replace(`.0${ending}`, ending);
            }
            else if (formatted.endsWith(`.00${ending}`)) {
                formatted = formatted.replace(`.00${ending}`, ending);
            }
            else if (formatted.includes('.') && formatted.endsWith(`0${ending}`)) {
                let parts = formatted.split('.');

                parts[1] = parts[1].replace(`0${ending}`, ending);

                formatted = parts.join('.');
            }
        }

        // If we have cents (value has decimal but doesn't end with .00), ensure 2 decimal places
        if (formatted.includes('.') && !/\.\d{2}[kKmM]?$/.test(formatted)) {
            let parts = formatted.split('.');
            // If we only have one decimal place, add a zero
            if (parts[1].length === 1 || (parts[1].length === 2 && /[kKmM]$/.test(parts[1]))) {
                let suffix = parts[1].match(/[kKmM]$/)?.[0] || '';
                let decimalPart = parts[1].replace(/[kKmM]$/, '');
                parts[1] = decimalPart + '0' + suffix;
                formatted = parts.join('.');
            }
        }

        return formatted;
    }

    static moment = Moment;

    static currentTimezone() {
        return this.moment.tz.zone(this.moment.tz.guess(true)).abbr(new Date().getTime())
    }
    static timezones() {
        const currentTime = new Date().getTime();
        return this.map(this.moment.tz.names(), zone => {
            return `(${this.moment.tz.zone(zone).abbr(currentTime)}) ${this.startCase(zone)}`
        })
    }
    /**
     * [Note]
     *
     * @param {Integer} totalSeconds
     * @returns {String}
     */
    static durationForHumans(totalSeconds)
    {
        let minutes;
        let seconds;
        if (totalSeconds >= 60) {
            minutes = Math.floor(totalSeconds / 60);
            seconds = totalSeconds - minutes * 60;
        }
        let minuteString = !minutes ? '' : minutes > 1 ? `${minutes} minutes` : `${minutes} minute`;
        let secondString = !seconds ? '' : seconds > 1 ? `${seconds} seconds` : `${seconds} second`;

        return minutes && minuteString
            ? (seconds && secondString ? minuteString + ' and ' + secondString : minuteString)
            : secondString;
    }

    /**
     * [Note]
     *
     * @param {Array[mixed]} collection
     * @param {String} key
     * @returns {Array}
     */
    static pluck(collection, key) {
        let newCollection = [];
        for (let item of collection) {
            newCollection.push(item[key]);
        }
        return newCollection;
    }

    /**
     * [Note]
     *
     * @param {Integer} milliseconds
     * @returns {Promise}
     */
    static wait(milliseconds) {
        return new Promise(resolve => {
            setTimeout(() => resolve(), milliseconds);
        });
    }

    /**
     * [Note]
     *
     * @param {mixed} value
     * @returns {Boolean}
     */
    static isDefined(value) {
        return value !== null
            && value !== undefined
            && String(value).length > 0
    }

    /**
     * [Note]
     *
     * @returns {Boolean}
     */
    static inProductionEnv() {
        return laravel.config.APP_ENV == 'production';
    }

    /**
     * [Note]
     *
     * @returns Array
     */
    static hexToRgba(hex, opacity = 1) {
        // Expand shorthand form (e.g. "03F") to full form (e.g. "0033FF")
        let shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
        hex = hex.replace(shorthandRegex, function(m, r, g, b) {
            return r + r + g + g + b + b;
        });

        let result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
        return result ? `rgba(${Object.values({
            r: parseInt(result[1], 16),
            g: parseInt(result[2], 16),
            b: parseInt(result[3], 16),
            a: opacity
        }).join(",")})` : null;
    }

    /**
     * [Note]
     *
     * @returns Array
     */
    static genDirectionalValues() { // min and max included
        let value1 = Math.floor(Math.random() * (60 - 40 + 1) + 40);
        let value2 = 100 - value1;
        return [value1 + "%", value2 + "%"]
    }

    /**
     * [Note]
     *
     * @returns Object
     */
    static createStyledCircle(background, opacity = undefined) {
        const [t1, t2] = this.genDirectionalValues();
        const [b1, b2] = this.genDirectionalValues();
        const [l1, l2] = this.genDirectionalValues();
        const [r1, r2] = this.genDirectionalValues();

        let backgroundColor = background;
        if(opacity) {
            console.log('createStyledCircle', background)
            backgroundColor = this.hexToRgba(background, opacity);
        }

        return {
            backgroundColor,
            borderRadius: `${t1} ${t2} ${b1} ${b2} / ${l1} ${r1} ${r2} ${l2}`
        }
    }



    static shortTimeRange(start, end, divider = '-')
    {
        if (!start || !end) {
            return '---';
        }

        let startsAndEndsInThisYear = TB.moment().format('YYYY') === start.format('YYYY')
            && start.format('YYYY') === end.format('YYYY');
        let startsAndEndsInSameYear = start.format('YYYY') === end.format('YYYY');

        let startFormat = 'MMM Do YYYY',
            endFormat = startFormat;
        if (startsAndEndsInThisYear) {
            startFormat = 'MMM Do';
            endFormat = startFormat;
        } else if (startsAndEndsInSameYear) {
            startFormat = 'MMM Do';
            endFormat = 'MMM Do YYYY';

        }

        return start.format(startFormat)
            + divider
            + end.format(endFormat);
    }
}